<app-template-text
  (onblur)="onblur.emit()"
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [maxlength]="maxlength"
  [control]="control"
  [align]="align"
  [label]="label"
/>
